export const ru = {
  'errors.E00.unauthorized': 'Требуется вход в систему',
  'errors.E00.forbidden': 'Недостаточно прав для этого действия',
  'errors.E00.not_found': 'Запись не найдена',
  'errors.E00.validation_failed': 'Данные заполнены неверно',
  'errors.E00.identity_conflict': 'Автомобиль уже связан с другим клиентом',
  'errors.E00.idempotency_required': 'Для этой операции обязателен ключ идемпотентности',
  'errors.E00.idempotency_mismatch': 'Тот же ключ идемпотентности уже использован с другими данными',
  'errors.E00.totp_required': 'Требуется подтверждение вторым фактором',
  'errors.E00.totp_invalid': 'Неверный код подтверждения',
  'errors.E00.account_locked': 'Учётная запись временно заблокирована до {until}',
  'errors.E00.site_required': 'Не выбран объект',
  'errors.E00.shift_required': 'На объекте нет открытой смены',
  'errors.E00.shift_closed':
    'Смена уже закрыта. Устройство работает по старой смене — обновите состояние и повторите.',
  'errors.E00.sync_rejected': 'Операция синхронизации отклонена',
  'errors.E00.conflict': 'Конфликт данных',
  'errors.E00.rate_limited': 'Слишком много запросов, попробуйте позже',
  'errors.E00.internal': 'Внутренняя ошибка. Обратитесь к администратору',
  'errors.E00.password_too_short': 'Пароль короче {min} символов',
  'errors.E00.password_too_simple': 'Пароль должен содержать символы хотя бы двух разных видов: строчные, прописные, цифры, знаки',
  'errors.E00.login_taken': 'Такой логин уже занят',
  'errors.E00.pin_invalid': 'PIN — от 4 до 8 цифр',
  'errors.E00.role_not_grantable': 'Вам не разрешено выдавать эту роль',
  'errors.E00.employee_not_found': 'Сотрудник не найден',
  'errors.E00.last_admin': 'Это последний администратор сети — сеть нельзя оставить без управления',
  'errors.E00.totp_enrollment_required': 'Для вашей роли нужен второй фактор. Подключите приложение-аутентификатор',
  'errors.E00.wrong_password': 'Текущий пароль указан неверно',
  'errors.E00.self_forbidden': 'Свои роли и свой статус изменить нельзя',
  'errors.E00.site_code_taken': 'Объект с кодом {code} уже заведён',
  'errors.E00.site_has_open_shift': 'На объекте есть открытая смена — сначала закройте её',
  'errors.E00.totp_already_enrolled':
    'Второй фактор уже подключён. Сменить его можно после входа с текущим кодом или через сброс у администратора',
  'errors.E00.site_forbidden': 'Запись относится к объекту, к которому у вас нет доступа',
  'errors.E00.login_failed':
    'Неверный логин или пароль. После пяти ошибок вход закрывается на 15 минут',
  'errors.E00.payload_too_large': 'Слишком большой запрос: не больше {limit} байт',
  'errors.E00.pin_trivial': 'Слишком простой PIN: не используйте одинаковые цифры, 1234 и повторы',
  'errors.E00.totp_locked':
    'Слишком много неверных кодов. Проверка второго фактора закрыта на 15 минут, войдите заново позже',
  'errors.E00.device_unknown': 'Устройство не зарегистрировано. Привяжите его к объекту в админке',
  'errors.E00.device_revoked': 'Доступ устройства отозван. Обратитесь к администратору',
  'errors.E00.parent_rejected':
    'Операция зависит от отклонённой: {ref}. Разберите исходную операцию и повторите действие',
  'errors.E00.consent_required': 'Нужно согласие клиента на обработку персональных данных',
  'errors.E00.merge_invalid': 'Склейка невозможна: {reason}',
  'errors.E02.webhook_unauthorized': 'Колбэк камеры не прошёл проверку секрета',
  'errors.E02.site_not_configured': 'Распознавание номеров не настроено для объекта',
  'errors.E02.camera_unknown': 'Камера {camera} не заведена на объекте',
  'errors.E02.vendor_unknown': 'Неизвестный вендор распознавания: {vendor}',
  'errors.E02.vendor_unavailable': 'Вендор распознавания недоступен, работайте через ручной ввод',
  'errors.E02.payload_invalid': 'Колбэк камеры не удалось разобрать',
  'errors.E02.recognition_not_found': 'Распознавание не найдено',
  'errors.E02.already_acknowledged': 'Отрисовка по этому распознаванию уже подтверждена',
  'errors.E02.threshold_invalid': 'Порог уверенности должен быть от 0 до 1',
  'errors.E02.window_invalid': 'Окно дедупликации должно быть положительным',
  'errors.E05.plan_not_found': 'Тарифный план не найден',
  'errors.E05.plan_code_conflict': 'План с кодом {code} уже существует',
  'errors.E05.plan_archived': 'План снят с продажи, оформить по нему нельзя',
  'errors.E05.plan_in_use': 'По плану есть действующие подписки, его нельзя удалить — только снять с продажи',
  'errors.E05.subscription_not_found': 'Подписка не найдена',
  'errors.E05.subscription_exists': 'На этом автомобиле уже есть подписка по этому плану',
  'errors.E05.transition_not_allowed': 'Переход из «{from}» в «{to}» не предусмотрен',
  'errors.E05.not_active': 'Подписка не активна: текущий статус «{status}»',
  'errors.E05.already_charged': 'Списание за период {period} уже проведено',
  'errors.E05.charge_failed': 'Списание не прошло: {reason}',
  'errors.E05.charge_attempts_exhausted': 'Исчерпаны попытки списания: {attempts} из {max}',
  'errors.E05.vehicle_mismatch': 'Подписка оформлена на другой автомобиль',
  'errors.E05.limit_exceeded': 'Исчерпан лимит моек по подписке: использовано {used} из {limit}',
  'errors.E05.too_frequent': 'По этой подписке слишком частое использование: следующее не раньше {next}',
  'errors.E05.usage_visit_mismatch': 'Визит относится к другому автомобилю',
  'errors.E05.conversion_would_lose_value': 'Перевод уменьшил бы оплаченный объём: было {before}, стало бы {after}',
  'errors.E05.conversion_already_done': 'Абонемент {ref} уже переведён в подписку',
  'errors.E05.customer_not_found': 'Клиент не найден',
  'errors.E05.vehicle_not_found': 'Автомобиль не найден',
  'errors.E05.period_invalid': 'Период отчёта задан неверно',
  'errors.E05.gateway_unavailable': 'Платёжный канал недоступен, попробуйте позже',
  'errors.E12.device_not_found': 'Устройство не найдено в инвентаре',
  'errors.E12.device_already_revoked': 'Доступ устройства уже отозван',
  'errors.E12.site_not_found': 'Объект не найден',
  'errors.E12.release_not_found': 'Релиз не найден',
  'errors.E12.release_running': 'На контуре {channel} уже идёт релиз',
  'errors.E12.release_not_rollbackable':
    'Откат невозможен: релиз в статусе «{status}» либо точка возврата не записана',
  'errors.E12.backup_not_found': 'Резервная копия не найдена',
  'errors.E12.backup_running': 'Резервное копирование уже выполняется',
  'errors.E12.backup_incomplete': 'Копия не завершена, учение по ней проводить нельзя',
  'errors.E12.drill_failed': 'Учение по восстановлению не пройдено: расхождений {mismatches}',
  'errors.E12.restore_target_busy': 'База для учения занята предыдущим запуском',
  'errors.E12.service_not_found': 'Внешний сервис {code} отсутствует в реестре',
  'errors.E12.residency_violation':
    'Сервис обрабатывает персональные данные вне РК и не может быть допущен (ТЗ 8.4)',
  'errors.E12.metrics_unauthorized': 'Неверный токен доступа к метрикам',
  'errors.E12.metric_unknown': 'Неизвестный показатель: {metric}',
  'errors.E12.threshold_invalid': 'Порог задан неверно',
  'errors.E12.period_invalid': 'Период отчёта задан неверно',
  'errors.E12.pg_tool_missing':
    'Утилиты pg_dump и pg_restore недоступны. Задайте MOIKA_PG_TOOL_PREFIX либо установите postgresql-client',
  'errors.E08.period_invalid': 'Период отчёта задан неверно',
  'errors.E08.period_too_wide': 'Период слишком широкий: {days} дней при пределе {max}',
  'errors.E08.site_required': 'Не указан объект, а доступных объектов у роли нет',
  'errors.E08.dataset_unknown': 'Набор данных «{dataset}» не существует',
  'errors.E08.export_pii_forbidden': 'Выгрузка «{dataset}» содержит персональные данные и требует отдельного права',
  'errors.E08.policy_invalid': 'Недопустимое значение настройки метрик: {field}',
  'errors.E08.report_timeout': 'Отчёт не уложился в {limit} мс и был остановлен',

  'identification.reason.required': 'Выберите причину отказа от идентификации',
  'identification.declined': 'Клиент отказался от идентификации',

  'role.cashier': 'Кассир',
  'role.operator': 'Оператор',
  'role.site_manager': 'Управляющий объекта',
  'role.marketer': 'Маркетолог',
  'role.network_admin': 'Администратор сети',
  'role.auditor': 'Аудитор',

  'common.yes': 'Да',
  'common.no': 'Нет',
  'common.save': 'Сохранить',
  'common.cancel': 'Отмена',
  'common.loading': 'Загрузка…',
  'common.site': 'Объект',
  'common.network': 'Вся сеть',
} as const;
